import { readJson, writeJson } from './storage';

/** How far the player got in the tutorial, so it can be resumed and the menu can offer it. */
export interface TutorialProgress {
  /** Index of the lesson to open next. */
  readonly lesson: number;
  /** Lessons solved, by id. */
  readonly solved: readonly string[];
  /** Every lesson has been seen through to the end once. */
  readonly completed: boolean;
}

const KEY = 'tutorial.v1';

export const NEW_TUTORIAL: TutorialProgress = Object.freeze({
  lesson: 0,
  solved: [],
  completed: false,
});

function validate(v: unknown): TutorialProgress | null {
  if (typeof v !== 'object' || v === null) return null;
  const p = v as Partial<Record<keyof TutorialProgress, unknown>>;
  return {
    lesson:
      typeof p.lesson === 'number' && Number.isInteger(p.lesson) && p.lesson >= 0 ? p.lesson : 0,
    solved: Array.isArray(p.solved)
      ? p.solved.filter((x): x is string => typeof x === 'string')
      : [],
    completed: p.completed === true,
  };
}

export const loadTutorial = (): TutorialProgress => readJson(KEY, validate) ?? NEW_TUTORIAL;

export const saveTutorial = (p: TutorialProgress): string | null => writeJson(KEY, p);

/** Where the player stands: never started, part way through, or done. */
export function tutorialStatus(p: TutorialProgress): 'new' | 'started' | 'completed' {
  if (p.completed) return 'completed';
  return p.lesson > 0 || p.solved.length > 0 ? 'started' : 'new';
}
